import { DateTime } from 'luxon'

import composeRichText from '@/client/services/richText/composeRichText'

// TODO: Allow admins to set this or have individual ones per role
export const DEADLINE = DateTime.local(2024, 5, 1, 18, 0, 0, { zone: 'America/Los_Angeles' })

export const DEFAULT_OFFER_MESSAGE = composeRichText(ctx => [
  ctx.paragraph(
    'Our next steps are to get you onboarded over the next few weeks. Onboarding will take about [2-4 weeks].'
  ),
  ctx.paragraph(''),
  ctx.paragraph(
    `Once you hit the accept button below, you'll be added to the team slack channel where you can start getting to know your team mates! Your team's co-leads/supervisor will reach out to you over slack within 1-2 weeks to get you trained for the new role. Please ensure you've completed all training your co-leads/supervisor provides before you commence your responsibilities!`
  ),
  ctx.paragraph(''),
  ctx.paragraph(
    'Additionally, there are a set of trainings all volunteers must complete which we call our ',
    ctx.text('universal onboarding', { bold: true }),
    '. This is about a 2-3 hour time commitment and consists of reviewing the ',
    ctx.linkExternal(
      'https://coda.io/d/_dLElbvGzPQO/Volunteer-Team-Handbooks_sujGXqbb',
      'Volunteer Handbook'
    ),
    ' and completing a series of ',
    ctx.linkExternal('https://coda.io/d/_dLElbvGzPQO/Trainings_su-Lf5Bx', 'trainings'),
    ` designed to prepare you for volunteering at Schoolhouse. Please note if the above trainings aren't completed by the end of your onboarding period, which will be around [month] your role may be revoked due to inactivity. You can always reference `,
    ctx.linkExternal('https://coda.io/d/_dLElbvGzPQO/Onboarding_su03UwIU#_luPDwx16', 'this page'),
    ' for your universal onboarding instructions.'
  ),
  ctx.paragraph(''),
  ctx.paragraph(`Congratulations again — we're excited to work with you!`),
])
